function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 512.311 512.311",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215.187 49.034C100.484 49.034 7.5 142.019 7.5 256.721s92.984 207.687 207.687 207.687c114.681 0 207.652-92.951 207.686-207.624H215.187V49.034z",
    style: {},
    fill: "#54d9f8",
    "data-original": "#54d9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.873 256.783c-.033 111.32-87.649 202.162-197.685 207.38 3.314.157 6.647.244 10 .244 114.681 0 207.652-92.951 207.686-207.624h-20.001zM195.187 256.783h20V49.034c-6.748 0-13.417.333-20 .963v206.786z",
    style: {},
    fill: "#00cbf5",
    "data-original": "#00cbf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.873 256.783H215.249l157.084 135.728c31.477-36.395 50.524-83.836 50.54-135.728z",
    style: {},
    fill: "#ffc472",
    "data-original": "#ffc472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.776 256.783c-1.354 47.196-18.453 90.441-46.23 124.68l12.787 11.048c31.477-36.395 50.524-83.836 50.54-135.728h-17.097z",
    style: {},
    fill: "#ff9257",
    "data-original": "#ff9257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.187 14.034v207.749h207.686l.001-.062c-.001-114.702-92.985-207.687-207.687-207.687z",
    style: {},
    fill: "#ff91a7",
    "data-original": "#ff91a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.187 14.034v17.821C361 38.346 437.873 113.766 437.873 221.721l-.001.062h20l.001-.062c0-114.702-92.984-207.687-207.686-207.687z",
    style: {},
    fill: "#ff5477",
    "data-original": "#ff5477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.501 109.693C30.817 147.291 7.5 199.283 7.5 256.721c0 114.702 92.984 207.687 207.687 207.687 114.681 0 207.652-92.951 207.686-207.624H331",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 256.783H215.187V49.034c-51.894 0-99.343 19.033-135.747 50.499M215.249 256.783l157.084 135.728",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.003 52.06c-33.854-23.952-75.192-38.026-119.817-38.026v207.749h207.686l.001-.062c0-64.373-29.287-121.906-75.264-160.001M416.436 8.346h60.437M446.436 38.346h64.875M416.436 38.346h14.875M.562 473.965H61M30.562 503.965h64.876M.562 503.965h14.875M417.436 407.502h60.437M447.436 437.502h64.875M417.436 437.502h14.875M376 121.189l90-44.937M361 330.658l90 44.938M25.994 436.127l90-44.938",
    style: {
      strokeWidth: 15,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    "data-original": "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage);
export default __webpack_public_path__ + "static/media/usage.0b2758614819649f01e3c8152feab62e.svg";
export { ForwardRef as ReactComponent };